/**
 * Permisos de eliminar en el formulario de la matriz de empresa (spec
 * 2026-10-07 §4): encenderlos o apagarlos exige rango ≥ 60 (lib/rank
 * canToggleDelete; el servidor lo exige también). Para quien no llega, esas
 * casillas salen deshabilitadas con el motivo y conservan su valor.
 * DELETE_FIELDS son los campos de formulario de lib/rank.DELETE_FLAGS (el test
 * exige que coincidan con fieldNameOf de permission_matrix).
 */
export const DELETE_FIELDS = [
  'folder_delete', 'file_delete', 'file_delete_xml', 'file_delete_reference',
  'file_delete_linked', 'file_delete_accounting',
];

export const DELETE_LOCK_REASON = 'Solo contador, supervisora o root pueden dar o quitar permisos de eliminar.';

export const deleteLockedMap = (canToggle) => (
  canToggle ? {} : Object.fromEntries(DELETE_FIELDS.map((f) => [f, DELETE_LOCK_REASON]))
);

/**
 * Sin permiso para tocar eliminar, un lote de campos nuevo (la siembra del rol
 * o los permisos por defecto) no puede cambiar esas casillas: conservan el valor
 * que `current` (form.getFieldsValue()) ya tenía, o false.
 */
export const keepDeleteFields = ({ fields, current, canToggle }) => (
  canToggle
    ? fields
    : fields.map((f) => (DELETE_FIELDS.includes(f.name) ? { ...f, value: !!(current && current[f.name]) } : f))
);
